import { EBillingStatus, TPaymentEvent } from "./provider";

export enum EInvoiceChargeType {
    VISIT = 'VISIT',
    SERVICE = 'SERVICE',
    OTHER = 'OTHER',
}

export enum EInvoiceRelatedType {
    APPOINTMENT = 'APPOINTMENT',
    SERVICE = 'SERVICE',
    OTHER = 'OTHER',
    TEXT_VISIT = 'TEXT_VISIT',
}

export type TInvoiceLineItem = {
    chargeType: EInvoiceChargeType;
    description: string;
    quantity: number;
    amount: number;
    unitPrice: number;
    relatedId?: number;
    relatedType?: EInvoiceRelatedType;
};

export type TSaveOrUpdateInvoice = {
    id?: number;
    clientId: number;
    issueDate: string;
    dueDate: string;
    noteToPatient?: string;
    lineItems: TInvoiceLineItem[];
    sendInvoice: boolean;
    /** Source text visit id for recurrence per-visit payment path (no-card flow) */
    sourceTextVisitId?: number;
};

export type TInvoice = {
    balanceAmount: number;
    cancelledAt: string;
    cancelledBy: number;
    clientId: number;
    createdAt: string;
    createdBy: number;
    dueDate: string;
    id: number;
    invoiceNo: string;
    invoicePdfUrl: string;
    invoiceQrcodeUrl: string;
    invoiceSource: string;
    invoiceType: string;
    issueAt: string;
    issueDate: string;
    klarityUserId: number;
    noteToPatient: string;
    paidAmount: number;
    providerId: number;
    refundAmount: number;
    status: EBillingStatus;
    totalAmount: number;
    updatedAt: string;
};

export type TInvoiceLineItemDetail = {
    amount: number;
    chargeType: EInvoiceChargeType;
    createdAt: string;
    description: string;
    id: number;
    klarityUserInvoiceId: number;
    quantity: number;
    relatedId: number;
    relatedType: EInvoiceRelatedType;
    unitPrice: number;
};

export type TInvoiceDetail = {
    events: TPaymentEvent[];
    invoice: TInvoice;
    lineItems: TInvoiceLineItemDetail[];
};

export interface IKlarityUserPaymentMethodVo {
    id: number;
    klarityUserId: number;
    cardBrand: string;
    cardLast4: string;
    cardExpMonth: string;
    cardExpYear: string;
    cardType?: string;
    paymentChannelCode?: string;
    paymentMethodType?: string;
    stripePmId?: string;
    isDefault?: boolean;
    isVerified?: boolean;
    status?: string;
    createdAt?: string;
    metaData?: string;
    verificationChargeId?: string;
    verificationPaymentIntentId?: string;
    verificationRefundId?: string;
    verifiedAt?: string;
}

export type TGetPatientPaymentMethodListParams = {
    clientId: number;
    paymentChannel?: 'SQUARE' | 'BRAINTREE' | 'STRIPE';
    paymentMethodType?: 'CREDIT_CARD' | 'PAYPAL' | string;
};

export type TPaymentCheckoutVo = {
    brainTreeClientToken?: string;
    squareApplicationId?: string;
    squareLocationId?: string;
};

export type TProviderAddPaymentMethodReq = {
    clientId: number;
    paymentToken: string;
    paymentChannel?: 'SQUARE' | 'BRAINTREE' | 'STRIPE';
    paymentType?: 'CREDIT_CARD' | 'PAYPAL' | string;
};

export type TInvoicePayRequest = {
    initiatedBy?: 'PATIENT' | 'PROVIDER';
    invoiceNo: string;
    clientId?: number;
    payAmount?: number;
    paymentMethodId?: string;
    paymentToken?: string;
    paymentType: 'CREDIT_CARD' | 'APPLE_PAY' | 'GOOGLE_PAY' | 'PAYPAL' | 'VENMO' | 'PAYPAL_PAY_LATER';
};

export type TInvoicePayResult = {
    amount?: number;
    billingId?: number;
    channelTransactionId?: string;
    errorCode?: string;
    errorMessage?: string;
    invoiceId?: number;
    success: boolean;
};